import { MouseEventHandler } from 'react';

import { OfferSummaryContainer } from '../../../common/OfferCard/OfferSummaryContainer';
import { OfferDetails } from '../../../components/OfferCard/components/OfferDetails';
import { OfferSupplierAndTotals } from '../../../components/OfferCard/components/OfferSupplierAndTotals';

interface OfferInformationProps {
    onClick?: MouseEventHandler<HTMLDivElement>;
    isBestLiterPrice?: boolean;
    isRecommended?: boolean;
}

export const OfferSummary = ({ onClick, isBestLiterPrice, isRecommended }: OfferInformationProps) => {
    return (
        <OfferSummaryContainer onClick={onClick} positiveHover={isBestLiterPrice} specialHover={isRecommended}>
            <OfferSupplierAndTotals isBestLiterPrice={isBestLiterPrice} />
            <OfferDetails />
        </OfferSummaryContainer>
    );
};
